import React from 'react';

import { observer } from 'mobx-react';

import classes from './ParticipantsTable.module.scss';
import { TitleRow } from './TitleRow/TitleRow';
import { ParticipantRow } from './ParticipantRow/ParticipantRow';
import { participantsListStore } from '../../../../../stores/participantsListStore';
import { ParticipantRowInfo } from '../../../../../interfaces/participants-list/ParticipantRowInfo';
import { openModal } from '../../../../../../shared/utils/reactUtils/openModal/openModal';
import { EditParticipantModal } from '../EditParticipantModal/EditParticipantModal';

const ParticipantsTable = observer(() => {
  const { participantsList, deleteParticipant } = participantsListStore;

  const handleDelete = async (id: number) => {
    await deleteParticipant(id);
  };

  const handleEdit = (participant: ParticipantRowInfo) => {
    openModal((closeModal) => (
      <EditParticipantModal participant={participant} onClose={closeModal} />
    ));
  };

  return (
    <div className={classes.participantsTable}>
      <TitleRow />
      {participantsList.map((participant) => (
        <ParticipantRow
          key={participant.id}
          participant={participant}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      ))}
    </div>
  );
});

export { ParticipantsTable };
